import { render, staticRenderFns } from "./new_investment_types.vue?vue&type=template&id=d7dfad0e&"
import script from "./new_investment_types.vue?vue&type=script&lang=js&"
export * from "./new_investment_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports